import * as React from "react"
import { useEffect } from "react"
import { array, object } from "yup"
import {useValidatorSeeker} from "@ui-seeker/app"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {PRICING_ROUTES, GROUPED_BY, COMMON_FILTER_KEYS, PRODUCT_PAGE_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import {
	isLoadingCommonFilters,
	sku,
	splitKpi,
	disabledCommonFiltersSubmit,
	country,
	errors,
	haveErrors,
	isSystemBusy,
	groupedBy
} from "@signals"
import { PriceEvolutionIsEmpty } from "./@signals"


export default function PricingPriceEvolutionFilters() {
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRICING_ROUTES.PRICE_EVOLUTION_ID, PRICING_ROUTES.ACCESS_KEY)

	const skuLimit = splitKpi.value.includes(GROUPED_BY.RETAILER) ? 10 : 100

    const dataValidator = useValidatorSeeker({
		skuPricingEvo: sku.value,
		country: country.value
	}, object({
		...splitKpi.value.includes(GROUPED_BY.RETAILER) && {
			skuPricingEvo: array().min(1, 'At least one SKU is required').max(10, 'Maximum 10 SKUs are allowed')
		},
		country: array().min(1, 'At least one country is required')
	}))

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	useEffect(() => {
        disabledCommonFiltersSubmit.value = !dataValidator.isValid || haveErrors.value
		errors.value = {
			...Object.fromEntries(Object.entries(errors.value).filter(([k, _]) => !['country', 'skuPricingEvo'].includes(k))),
			...dataValidator.errors
		}
    }, [dataValidator.isValid, JSON.stringify(dataValidator.errors), haveErrors.value])

    const normalizedUserFilters = userFilters?.country && !Array.isArray(userFilters.country)
        ? { ...userFilters, country: [userFilters.country] }
        : userFilters

	return <Box data-tour="price-evolution-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, skuGroup: true, splitKpi: true,
            productsInStock: true, blankSpace: true,
			favFilters: true, withShippingPrice: true
		}}
		compProps={{
			sku: { grid: { md: 4 }, checkLimitSku: skuLimit },
            productsInStock: { grid: { md: 2 } },
			withShippingPrice: { grid: { md: 6, xs: 6 }},
            blankSpace: { grid: { md: 10 } },
            splitKpi: {
				grid: { md: 2 },
				excludeOptions: [GROUPED_BY.BRAND, GROUPED_BY.SELLER, GROUPED_BY.COUNTRY, GROUPED_BY.COMPANY],
				onChange: (e) => {
					if (e.target.value?.length)
						splitKpi.value = e.target.value[1]
				}
			},
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE,
					COMMON_FILTER_KEYS.PRODUCTS_IN_STOCK
				],
				dashboardKey: PRICING_ROUTES.PRICE_EVOLUTION_ID
			}
		}}
		onSubmit={() => {
			PriceEvolutionIsEmpty.value = false
			isSystemBusy.value = false
            isLoadingCommonFilters.value = true
        }}
		defaultValues={normalizedUserFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}